import { isElectron } from "./isElectron";

export function openExternal(url: string) {
  if (isElectron()) {
    window.electron?.openExternal(url);
  } else {
    window.open(url, '_blank')?.focus();
  }
}